import { UiSource } from '@weave/schema-gen-ts/dist/shared/wsearch/v1/ui_source.pb';
import { useSearchHistory } from './use-search-history';

export const SearchHistory = ({ id }: { id: UiSource }) => {
  useSearchHistory(id);
  return null;
};
